import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Flex, Skeleton, Typography } from 'antd'
import { viewCheckImage } from 'src/app/shared/services/ViewTransactionService'
import Image from '..'
import './index.scss'
import NoCheckImage from '../../../../../../assets/images/no-check-image.png'
import { colorBgGray3 } from 'src/app/themes/primaryThemeDefault'

interface CheckImagesProps {
  id: string
  checkNumber?: string
}
const CheckImages = ({ id, checkNumber = '' }: CheckImagesProps) => {
  const { t } = useTranslation()
  const [selected, setSelected] = useState(0)
  const [frontImgUrl, setFrontImgUrl] = useState('')
  const [backImgUrl, setBackImgUrl] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  const resetCheckImage = () => {
    setFrontImgUrl('')
    setBackImgUrl('')
    setSelected(0)
  }

  const getCheckImage = useCallback(async () => {
    if (id) {
      try {
        setIsLoading(true)
        const response = await viewCheckImage(id)

        setFrontImgUrl(response?.data?.frontImage?.fileUrl)
        setBackImgUrl(response?.data?.backImage?.fileUrl)
      } catch (e) {
        resetCheckImage()
      } finally {
        setIsLoading(false)
      }
    }
  }, [id])

  useEffect(() => {
    getCheckImage()

    return () => {
      resetCheckImage()
    }
  }, [getCheckImage])

  const toggleItems = useMemo(
    () => [
      {
        key: 0,
        label: t('OverallFunctionality:check_images_front_btn'),
        img: frontImgUrl,
      },
      {
        key: 1,
        label: t('OverallFunctionality:check_images_back_btn'),
        img: backImgUrl,
      },
    ],
    [frontImgUrl, backImgUrl, t],
  )

  return (
    <Flex vertical gap={16} className='check-images' align={'center'}>
      <Flex justify='space-between' align='center'>
        <Flex className='toggle-wrap' gap={4}>
          {toggleItems.map((item) => (
            <div
              key={item.key}
              className={`${selected === item.key ? 'selected' : ''} toggle-item`}
              onClick={() => setSelected(item.key)}
            >
              <Typography.Text style={{ fontSize: '16px', lineHeight: '22px' }}>{item.label}</Typography.Text>
            </div>
          ))}
        </Flex>
      </Flex>

      {isLoading ? (
        <Skeleton active={isLoading} />
      ) : toggleItems[selected]?.img ? (
        <Image checkNumber={checkNumber} width={704} height={315} src={toggleItems[selected]?.img} />
      ) : (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: 16,
            padding: 40,
            flexDirection: 'column',
          }}
        >
          <img
            style={{
              width: 40,
              height: 40,
            }}
            src={NoCheckImage}
            alt=''
          />
          <Typography
            style={{
              color: colorBgGray3,
              fontSize: 16,
            }}
          >
            {t('OverallFunctionality:no_check_image')}
          </Typography>
        </div>
      )}
    </Flex>
  )
}

export default CheckImages
